import { type SessionLogDetails } from '../../services/api/sessions';
import { cn } from '../../utils/cn';

import { describeSessionContext } from './customer-view';

export const SessionContextBar = ({ details }: { details: SessionLogDetails }) => {
  const rows = describeSessionContext(details);
  if (rows.length === 0) return null;

  return (
    <dl className="grid gap-x-4 gap-y-1 rounded-lg border border-slate-200 bg-white p-3 text-xs md:grid-cols-2">
      {rows.map((row) => (
        <div key={row.label} className="flex gap-2">
          <dt className="w-24 shrink-0 text-slate-500">{row.label}</dt>
          <dd className={cn('font-medium text-slate-900', row.tone === 'warn' && 'text-amber-700')}>
            {row.value}
          </dd>
        </div>
      ))}
    </dl>
  );
};
